import React, { memo } from 'react';

import { ArticleHeroCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import ArticleByline from '../ArticleByLine/ArticleByline';

import * as S from './ArticleHero.styles';

export interface ArticleHeroProps {
  data: ArticleHeroCMS;
}

const defaultProps: Partial<ArticleHeroProps> = {};

const ArticleHero: React.FunctionComponent<ArticleHeroProps> = ({
  data,
  ...rest
}) => {
  return (
    <S.ArticleHeroWrapper>
      <S.Hero src={data.image.url} {...rest} />

      <ArticleByline {...data} />
    </S.ArticleHeroWrapper>
  );
};

ArticleHero.defaultProps = defaultProps;

export default memo(ArticleHero);
